export default "__VITE_ASSET__C6Rs1qEu__"